import React from "react";
import { useSelector } from "react-redux";

const ForceRefreshModal = () => {
  const versionAction = useSelector((state) => state.version.versionAction);
  const forceRefreshMessage = useSelector((state) => state.version.forceRefreshMessage);
  const maintenanceMessage = useSelector((state) => state.version.maintenanceMessage);

  const isForceRefresh = versionAction === "FORCE_REFRESH";
  const isMaintenance = versionAction === "MAINTENANCE";

  if (!isForceRefresh && !isMaintenance) return null;

  const handleAction = () => {
    window.location.reload();
  };

  const message = isMaintenance
    ? maintenanceMessage || "We're currently down for maintenance. Please check back shortly."
    : forceRefreshMessage || "We've made critical updates. Please refresh to continue.";

  const buttonLabel = isMaintenance ? "Try Again" : "Refresh Page";
  const title = isMaintenance ? "Under Maintenance" : "Update Required";

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-[24px] p-[40px] max-w-[480px] w-full mx-4 flex flex-col items-center text-center shadow-xl">
        <div className="text-[48px] mb-4">{isMaintenance ? "🔧" : "🔄"}</div>
        <h2 className="text-[22px] font-[600] text-[#1B2B48] mb-3">{title}</h2>
        <p className="text-[15px] text-[#353535] mb-8 leading-relaxed">{message}</p>
        <button
          onClick={handleAction}
          className="btn-base btn-secondary w-full text-[16px] font-[500]"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default ForceRefreshModal;
